import React from 'react'
import ErrorBoundary from './shared/components/errorboundary/ErrorBoundary'
import { Route, Routes } from 'react-router'
const CustomMfaVerification = React.lazy(() => import('./modules/login/verification/CustomMfaVerification'))
const TotpRegistrationContainer = React.lazy(() => import('./modules/registration/totp/TotpRegistrationContainer'))

const AppMfaUnVerifiedRoutes = () => {
  return (
    <ErrorBoundary message="Page failed to load, please refresh your browser to try again.">
      <React.Suspense fallback={<></>}>
        <Routes>
          <Route path="/register" element={<TotpRegistrationContainer />} />
          <Route path="*" element={<CustomMfaVerification />} />
        </Routes>
      </React.Suspense>
    </ErrorBoundary>
  )
}

export default AppMfaUnVerifiedRoutes
